import "../App.css";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";

const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};

const Rental = () => {
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun: Rental</title>
        <meta name="title" content="Heartland Fun: Rental" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: Rental" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/rental" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <FadeInTitle>
        EVENT RENTAL
      </FadeInTitle>
      <br></br>
      <a href="tel:7858137921" className="Button Titillium Center">
        Get in Touch
      </a>
      <div className="Brake"></div>
      <p className="Blue InfoText Titillium Center FadeIn">
        Looking to add some thrill to your next birthday party, festival or special event? Look no further! Our arcade machines are the perfect way to make your vision a reality. With a wide range of options available, we can help you create an unforgettable experience that your guests will love. So what are you waiting for? Get in touch with us today and let's make your event one to remember!
      </p>
      <Footer></Footer>
    </div>
  );
};

export default Rental;